import React, { useRef, useState } from 'react';

import user_model from 'models/user_model';
import { useProfile, useToggleState } from 'xAppLib/Hooks';

import { Modal, Button, Icon, Form } from 'semantic-ui-react';
import UniForm from '../UniForm/UniForm';
import UniFieldSUI from '../UniForm/UniField-SUI';

const HEADER_AND_BUTTONS_HEIGHT = '200px';

const MedicalHistoryModal = ({ onClose, navigateToHobbies = false }) => {
	const [profile] = useProfile();
	const formRef = useRef(null);
	const [isLoading, turnIsLoadingOn, turnIsLoadingOff] = useToggleState();

	const handleClose = () => {
		if (navigateToHobbies) {
			app.trigger(app.events.SHOW_POPUP, {
				txt: 'Select Your Hobbies',
				pn: 'hobbies',
				noCloseBtn: true,
				cst_modal: true
			});
		}
		else 
			onClose();
	};

	const updateProfile = (d) => {
		if (!Object.keys(d).length) {
			handleClose();
			return;
		}

		turnIsLoadingOn();
		user_model.save_prof({ ...profile, ...d }, (result) => {
			if (result.profile) {
				Object.keys(d).forEach((k) => {
					// update old profile
					app.user.prof[k] = result.profile[k];
				});
			}
			turnIsLoadingOff();
			handleClose();
		});
	};

	return (
		<>
			<Modal.Content style={{ minHeight: `calc(100vh - ${HEADER_AND_BUTTONS_HEIGHT})` }}>
				<UniForm
					ref={formRef}
					name="MedicalHistory"
					onActForm={updateProfile}
					fields={user_model.PROF_MEDICAL_HISTORY}
					defaultValues={profile}
					onChange={(name, value) => {
						if (name === 'cons_has_allergies' && value === 'no') {
							return { cons_allergy: '' };
						}
					}}
				>
					{(values, valids, uf_this, fields) => {
						const args = { values, valids, uf_this };
						return (
							<Form size={!app.acl.app_use ? 'big' : undefined}>
								<UniFieldSUI fl={fields.cons_has_allergies} {...args} />
								{fields.cons_allergy && values.cons_has_allergies !== 'no' && <UniFieldSUI fl={fields.cons_allergy} {...args} />}
								<UniFieldSUI fl={fields.cons_medhist} {...args} />
								<UniFieldSUI fl={fields.cons_meds} {...args} />
							</Form>
						);
					}}
				</UniForm>
			</Modal.Content>
			<Modal.Actions>
				<Button data-testid='button-cancel' onClick={handleClose}>
					<Icon name="undo" /> Cancel
				</Button>
				<Button positive data-testid='button-save' onClick={() => formRef.current.actForm()} loading={isLoading}>
					<Icon name="save" /> Save
				</Button>
			</Modal.Actions>
		</>
	);
};

export default MedicalHistoryModal;
